import { OutlinedInput, OutlinedInputProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';

interface InputProps extends OutlinedInputProps {
    name: string;
    mask: string;
    maskChar?: string | null;
    change?: (cep: string, index: number) => void;
    index?: number;
    disabled?: boolean;
}
export function Mask({ mask, maskChar, change, index, disabled, ...props }: InputProps) {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={props.name}
            render={({ field }) => (
                <InputMask
                    mask={mask}
                    maskChar={maskChar === undefined ? '_' : maskChar}
                    alwaysShowMask={false}
                    value={field.value}
                    disabled={disabled}
                    onChange={(e) => {
                        field.onChange(e);
                        change ? change(e.target.value, index) : '';
                    }}
                    onBlur={field.onBlur}
                >
                    {/* @ts-ignore comment */}
                    {(inputProps) => <OutlinedInput {...props} {...inputProps} />}
                </InputMask>
            )}
        />
    );
}
